const UserStatuses = ["Pending", "Completed"];

export default UserStatuses;
